// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import BusinessCharacteristicModel from '../../model/business-characteristic-model';
import BusinessCharacteristicDTO from '../dto/business-characteristic-dto';
import dtoSchema from '../schemas/business-characteristic-schema';

export default abstract class BusinessCharacteristicModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<BusinessCharacteristicDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.name = data.name ?? undefined;
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;
  /**
  */
  name?: string;

  static toModel(dto: DeepPartial<BusinessCharacteristicDTO>): BusinessCharacteristicModel;
  static toModel(dto: DeepPartial<BusinessCharacteristicDTO> | undefined | null): BusinessCharacteristicModel | undefined;
  static toModel(dto: DeepPartial<BusinessCharacteristicDTO> | undefined | null): BusinessCharacteristicModel | undefined {
    return dto ? new BusinessCharacteristicModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<BusinessCharacteristicModel> | BusinessCharacteristicModel): BusinessCharacteristicDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      name: unwrapped.name,
    } as BusinessCharacteristicDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for BusinessCharacteristicModel, can not map to BusinessCharacteristicDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
